import { FaqChapter } from '@/entities/catalog-inside-page/FaqChapter/ui/FaqChapter.jsx'
import './ui/FaqChapter.scss'
export default FaqChapter
